import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const ExecCard = ({ first_name, last_name, email, bio, experience, education, sectors, practices, rating, available }) => {
  
  return (
    // <Card className="mb-3">
    //   <Card.Body>
    //     <img alt = "exec-partner image"></img>
    //     <h5>{first_name || 'Unknown'} {last_name || 'Unknown'} | Executive Partner</h5>
    //     <p><a href={`mailto:${email}`}>{email}</a></p>

    //     <div>
    //       <p>{bio}</p>
    //       <p><strong>Sector expertise:</strong> {sectors}</p>
    //       <p><strong>Domain expertise:</strong> {practices}</p>
    //       <p><strong>Experience:</strong> {experience}</p>
    //       <p><strong>Education:</strong> {education}</p>
    //       <p><strong>Rating:</strong> 
    //         <span style={{color: "gold"}}>
    //           {' '+'★'.repeat(rating) + '☆'.repeat(5 - rating)}
    //         </span>
    //       </p>

    //       <p><strong>Availability:</strong> 
    //         <span style={{color: available ? 'green' : 'red',fontWeight: "bold"}}>
    //           <></>{available ? ' ✔ Available' : ' ✘ Unavailable'}
    //         </span>
    //       </p>
    //     </div>
    
    //   </Card.Body>
    // </Card>
    <>
      <Row className='d-flex justify-content-center'>
        <Col md={4} className='d-flex justify-content-center'>
          <img alt = "exec-partner image"></img>
        </Col>
        <Col md={8} className='d-flex flex-column'>
          <div style={{border: '1px solid #c39ccc'}} className='p-3'> 
            <h5 style={{color : "#3333ff"}}>{first_name || 'Unknown'} {last_name || 'Unknown'} | Executive Partner, Paris </h5>
            <a style={{color : "#9416b2"}} href={`mailto:${email}`}>{email}</a>
          </div>
          <div style={{borderTop :"0" ,border: '1px solid #c39ccc'}} className='p-3 pb-0'>
            <p>{bio}</p>
            <p>Sector expertise:{sectors}</p>
            <p>Domain expertise: {practices}</p>
            <p>Degree: {education}</p>
          </div>
        </Col>
      </Row>
      <Row className='d-flex justify-content-center p-2'>
        <p style={{borderTop :"0" ,border: '1px solid #c39ccc'}} className='p-3'>{experience}</p>
      </Row>
    </>
  );
};

export default ExecCard;